import { ICategory } from 'app/main/shared/shared/table/components/category-name/category-name.component';
import { Pivot } from 'app/store/actions/IUser-data.dto';
import { CrmType } from '../../../../crm-login/crm-login.component';
import { IPageableResponse } from '../../../../global/pagging.dto';
import { FieldData, Orgfield, Personfield } from '../../edit-template/edit-template.dto';
import { IMetadataItemDto } from '../../settings/documentfields/metadata-item.dto';
import { TemplateType } from '../../templates/template.dto';
import { DocumentDetailsStatus, DocumentInternalReminder, DocumentVideoType, RecipientRoleDetail, Template, VisibilityEnum } from './document-details.dto';
import { DocumentStatusesEnum } from './document-statuses.enum';
import { IPinnedField } from '../document-right-sidebar/custom-columns';
import { ISection } from '../../settings/documenttype/document-type-settings-modal/document-type-settings.dto';

export interface IDocumentListingDto extends IPageableResponse<IDocumentDto> {
}


export interface IGetDocumentByIdAndNumber {
    allow_chat?: boolean | null;
    allow_forward?: boolean | null;
    attach_video?: boolean | null;
    category_id?: number | null;
    confirmation_message?: null | string;
    content: string;
    created_at: string;
    crm_type?: CrmType;
    deal_id?: number | null;
    deleted_at?: null | string;
    dk_password?: null | string;
    dk_password_hint?: null | string;
    dk_send_via_sms?: boolean | null;
    dk_type?: number | null;
    document_key?: boolean | null;
    document_number: string;
    document_price?: number | null;
    document_type_id: number;
    due_date?: null | string;
    folders_id?: number | null;
    id: number;
    invitation_message?: null | string;
    language: string;
    name: string;
    pdf_path?: null | string;
    recurring?: boolean | null;
    save_to_folder?: boolean | null;
    signing_deadline?: number | null;
    signing_reminder?: number | null;
    status: DocumentDetailsStatus;
    status_updated_at?: null;
    template_id?: number | null;
    thumbnail?: null | string;
    updated_at: string;
    user_id: number;
    video_title?: null | string;
    video_type: DocumentVideoType;
    video_url?: null | string;
    fields_datas: IDocumentFieldsData,
    visibility: VisibilityEnum;
    visible_name?: null;
    workspace_id: number;
}

export interface IDocumentDto {
    id: number,
    user_id: number,
    workspace_id: number,
    template_id?: number,
    document_type_id: number,
    template: Template,
    folders_id?: number,
    name: string,
    status: DocumentStatusesEnum,
    visible_name: string,
    language: string,
    recipient_roles: IRecipient_rolesDto[],
    status_updated_at?: string,
    document_type?: IDocumentTypesDto
    category_id?: number,
    category?: ICategory,
    categories?: ICategory[],
    fields_datas: IDocumentFieldsData,
    metodika_appointment_import?: IMetodikaAppointmentImport;
    metodika_status?: string;
    status_updated_manually: number,
    type: TemplateType,
    updated_at: string,
    document_internal_reminder?: DocumentInternalReminder[],
    is_reminders_expire?: boolean,
}

export interface IDocumentFieldsDataItemCommon {
    allow_multi_lines: 0 | 1,
    api_attribute: string, // TODO: set type from Metadata type
    calculation: string,
    column: string,
    conditional?: boolean,
    connected_parent_conditional_id: number[],
    created_at: Date,
    document_type_id: number,
    extra: [],
    field: string,
    field_block: number,
    field_fontsize: number,
    field_info: string,
    lock: 0 | 1,
    field_name: string,
    field_required: 0 | 1,
    field_section: string,
    field_style: 0 | 1,
    hidden: 0 | 1,
    linked_conditional_id: [],
    name: string,
    order: number,
    placeholder: null,
    prefixid: string,
    recipient_id: number,
    reverse_conditional?: 0 | 1,
    role_name?: string,
    select_type_text: string,
    selected_field: number,
    selected_field_role_id?: number,
    selected_field_type_id: number,
    selected_for_role_id: number,
    selected_type: string,
    tag_view: 0 | 1,
    type: string,
    type_of: string,
    updated_at: Date,
    uuid: string,
    validation: [],
    validation_type?: string,
    value: string
    calculation_decimal: string;
    connected_parent_calculation_id: number[];
    const_eval_calculation: string;
    enable_calculation: number;
    enable_conditional: number;
    eval_calculation: 0 | 1;
}

export interface IDocumentFieldsDataItem extends IDocumentFieldsDataItemCommon {
    hide_label: 0 | 1,
    multi_choice: 0 | 1,
    options: {
        crm_option_id?: number,
        id: number,
        meta_data_id: number,
        name: string,
        user_id: number,
        value: string
    }[],

}

export interface IMetodikaAppointmentImport {
    id: number;
    appointment_id: number;
    document_id: number;
    country: string;
    last_metodika_update: string;
    created_at: string;
    updated_at: string;
}

export interface IDocumentFieldsData {
    data: FieldData[],
    dataable_id: number,
    dataable_type: string,
    id: number,
    user_id: number,
    workspace_id: number
    created_at?: string,
    updated_at?: string,
}

export interface IRecipient_rolesDto {
    id: number;
    organization?: { id: number, name: string };
    organization_id?: number;
    recipient: IRecipientDto;
    recipient_id: number;
    role_name: string;
    roleable_id: number;
    roleable_type: string;
    personfields: Personfield[];
    orgfields: Orgfield[];
    recipient_role_detail:RecipientRoleDetail,
}

export interface IRecipientDto {
    firstname?: string,
    id: number,
    lastname?: string,
    deleted_at?: string
}

export interface IDocumentTypesListingDto {
    data: IDocumentTypesDto[];
}

export interface IDocumentTypesDto extends Partial<Pivot> {
    created_at?: string;
    document_type?: string;
    description?: string;
    contract_controls_count?: number;
    documents_count?: number;
    templates_count?: number;
    document_type_data?: DocumentTypeData;
    id?: number;
    is_default?: boolean;
    image_type?: string;
    updated_at?: string;
    user_id?: number;
    selector_for?: string;
    workspace_id?: number;
    selected_category_ids?: number[];
    sections?: ISection[];
}

export interface DocumentTypeData {
    id: number;
    document_type_id: number;
    status: number;
    users: number;
    cost: number;
    period_renewal: number;
    revenue: number;
    manager: number;
    attach_document: number;
    audit_trail: number;
    todo_list: number;
    linked_contracts: number;
    contacts: number;
    comments: number;
    contract_events: number;
    created_at: string;
    updated_at: string;
    document_type_custom_boxes: DocumentTypeCustomBoxes[];
}


export interface DocumentTypeCustomBoxes {
    id: number;
    document_type_data_id: number;
    status: number;
    name: string;
    created_at: string;
    updated_at: string;
    document_type_custom_boxes_data: DocumentTypeCustomBoxesDaum[];
}

export interface DocumentTypeCustomBoxesDaum {
    id: number;
    user_id: number;
    workspace_id: number;
    custom_boxes_data_id?: number;
    document_type_box_id: number;
    meta_data_id: number;
    status: number;
    created_at: string;
    updated_at: string;
    field_order: number;
    meta_data: MetaData;
    value?: string;
    contract_control_custom_boxes_data: ContractControlCustomBoxesData;
}

export interface MetaData {
    id: number;
    user_id: number;
    workspace_id: number;
    meta_data_name: string;
    meta_data_type: string;
    section: string;
    api_attribute: string;
    source: string;
    is_required: number;
    meta_data_description: string;
    created_at: string;
    updated_at: string;
    meta_data_option: MetaDataOptions[];
}


export interface MetaDataOptions {
    id: number;
    name: string;
    value: string;
    show: number;
}

export interface ContractControlCustomBoxesData {
    id: number;
    custom_boxes_data_id: number;
    contract_control_id: number;
    order: number;
    value: string;
    created_at: string;
    updated_at: string;
}

export interface IUserGroupFilterDto {
    id: number,
    name: string
}

export interface IUserGroupFilter {
    id: number,
    name: string,
    group: OwnerFilterType
}

export enum OwnerFilterType {
    me = '',
    group = 'Groups',
    user = 'Users',
}

export enum OwnerOptions {
    me = 'me'
}

export interface IDocumentTypeLayoutSettingsDTO {
    document_columns?: CustomColumns[];
    document_preview: CustomColumns[];
    categories?: number[];
}

export interface CustomColumns {
    cid?: string; // only for default columns
    type: string;
    label: string;
    order: number;
    doc_id?: number;
    status: number;
    meta_data?: IMetadataItemDto
    field_name: string;
}
